import apiRequest from "../../../apiRequest";
import { endPoints } from "../../../apis";

/**
 * GET /bank/all
 */
export const fetchBanks = async (params = {}) => {
  // console.log(params);
  return apiRequest.get(endPoints.GET_BANKS, { params });
};

/**
 * GET /bank
 */
export const fetchBank = async (params = {}) => {
  return apiRequest.get(endPoints.GET_BANK, { params });
};

/**
 * GET /bank/:id
 */
export const fetchBankById = async (id, params = {}) => {
  return apiRequest.get(
    endPoints.GET_SINGLE_BANK.replace(":id", id),
    { params }
  );
};

/**
 * POST /bank/create
 */
export const createBank = async (data) => {
  return apiRequest.post(endPoints.ADD_BANK, data);
};

/**
 * PUT /bank/:id
 */
export const updateBank = async (id, data) => {
  return apiRequest.put(endPoints.UPDATE_BANK.replace(":id", id), {
    id,
    ...data,
  });
};


/**
 * PATCH /bank/:id/status
 */
export const updateBankStatus = async (id, status) => {
  console.log(id, status)
  return apiRequest.put(
    endPoints.UPDATE_BANK_STATUS.replace(":id", id),
    { status }
  );
};


/**
 * DELETE /bank/:id
 */
export const deleteBank = async (id) => {
  return apiRequest.delete(
    endPoints.DELETE_BANK.replace(":id", id)
  );
};
